<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

const props = defineProps({
    data: {
        type: Object,
        default: () => ({})
    },
    contactLabel: {
        type: String,
        default: ""
    },
});

const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

const open = ref(false);
const rootEl = ref(null);

const onDocClick = (e) => {
    if (!rootEl.value) return;
    if (!rootEl.value.contains(e.target)) open.value = false;
};
onMounted(() => document.addEventListener("pointerdown", onDocClick));
onBeforeUnmount(() => document.removeEventListener("pointerdown", onDocClick));

</script>

<template>
    <div ref="rootEl" class="fixed bottom-20 phone:bottom-10 right-2 phone:right-3.5 z-50" @keydown.escape="open = false">
        <kd-icon-arrow-left 
            @click="toTop" 
            class="fixed bottom-37 phone:bottom-32 right-4 phone:right-9 rotate-90 cursor-pointer
                   transition-all duration-300 ease-out opacity-0 drop-shadow-ts-tight
                   translate-y-2 pointer-events-none scrolled-deep:opacity-100
                   scrolled-deep:translate-y-0 scrolled-deep:pointer-events-auto" 
            size="30" 
            fill="black" 
        />
        <div class="relative group">
            <!-- Trigger -->
            <button 
                type="button" 
                @click="open = !open" 
                :aria-expanded="open ? 'true' : 'false'"
                class="flex flex-col items-center gap-1 rounded-md shadow-ts-white px-3 py-2 text-white bg-black"
            >
                <span class="flex flex-col items-center gap-0.5">
                    <kd-icon-phone size="25" fill="white" />
                    <kd-icon-mail size="25" fill="white" />
                    <span class="hidden phone:block text-sm">{{ contactLabel }}</span>
                </span>
            </button>
            <!-- Panel -->
            <div 
                class="absolute right-0 bottom-0 rounded-md bg-white text-black 
                shadow-2xl border-black/50 overflow-hidden w-max z-10
                transition-all duration-200 ease-out
                can-hover:group-hover:opacity-100 can-hover:group-hover:visible can-hover:group-hover:translate-y-0"
                :class="open ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible translate-y-2'"
            >
                <div class="h-9 flex items-center justify-center px-3 text-white text-base font-semibold bg-black">
                    {{ props.data.title }}
                </div>

                <div class="p-3 space-y-2 text-sm">
                    <div class="flex items-center gap-2">
                        <kd-icon-phone size="20" fill="black" />
                        <a :href="'tel:' + props.data.phone" class="hover:underline">{{ props.data.phone }}</a>
                    </div>

                    <div class="flex items-center gap-2">
                        <kd-icon-mail size="20" fill="black" />
                        <a :href="'mailto:' + props.data.email" class="hover:underline">{{ props.data.email }}</a>
                    </div>

                    <div class="mt-2">
                        <div class="text-base mb-2">{{ props.data.hours_title }}</div>
                        <div class="text-sm flex">
                            <div class="flex flex-col gap-y-2 text-left pr-2">
                                <div v-for="(row, i) in props.data.hours" :key="'day-' + i">
                                    {{ row.day }}
                                </div>
                            </div>
                            <div class="flex flex-col gap-y-2">
                                <div v-for="(row, i) in props.data.hours" :key="'time-' + i">
                                    {{ row.time }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>